import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { QueovalItem, BObjectModel, ActionCoBoModel, HtmlBase, PropertyGroup, Select, QueovalParam, BreadDik, QResult, InputModel } from '../../../models';
import { HttpService, CoreService } from '../../../services';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-action-co-bo',
  templateUrl: './action-co-bo.component.html',
  styleUrls: ['./action-co-bo.component.css', '../action-co-card.component.css']
})

export class ActionCoBoComponent implements OnInit {

  public isReloading: boolean = false;
  public isMainContact: boolean = true;
  public BoModel = new BObjectModel();
  public customerType: string = 'Prospect';

  @Input() mode: string;
  @Input() idDonneePere: string;
  @Input() idDonneeFils: string;
  @Input() idRelation: string;
  @Input() listValue: Array<Select>;
  @Input('mainContact') set SetMainContact(value: boolean) {
    this.isMainContact = value;
  }

  @Output() close: EventEmitter<QueovalItem> = new EventEmitter<QueovalItem>();

  constructor(
    protected http: HttpService,
    protected indParam: CoreService
  ) { }

  public ngOnInit(): void {

    switch (this.mode) {
      case 'CUSTOMER':
        this.InitBo('CUSTOMER', 'REL_BO_CENT_BO_CPPT');
        break;
      //coté serveur si la relation est modifiée en fonction de si la personne morale est client ou prospect
      case 'CONTACT':
        this.InitBo('CONTACT', this.isMainContact ? 'REL_BO_CPPT_BO_DIRIGEANT' : 'REL_BO_CPPT_BO_CONTACT');
        break;
      case 'DEVIS':
        if ((!this.idDonneeFils || this.idDonneeFils === '0') && this.listValue.length > 0) {
          this.idDonneeFils = this.listValue[0].id;
        }
        this.InitBo('DEVIS', 'REL_BO_MFORADQ_BO_DEVIS');
        break;
      case 'ACTIONCO':
        this.InitBo('ACTIONCO', 'REL_BO_CSOC_BO_ACTIONCO');
        break;
      case 'PROJET':
        this.InitBo('PROJET', 'REL_BO_ACTIONCO_BO_MFORADQ');
        break;
      case 'PM_EDIT':
        this.InitBo('PM_EDIT', 'REL_BO_CENT_BO_CPPT');
        break;
      case 'PP_EDIT':
        this.InitBo('PP_EDIT', 'REL_BO_CENT_BO_CONTACT');
        break;
      case 'PM_LDM':
        this.InitBo('PM_LDM', 'REL_BO_CPPT_BO_LDM');
        break;
      case 'PP_LDM':
        this.InitBo('PM_LDM', 'REL_BO_CSOC_BO_LDM');
        break;
      case 'MISSION':
        this.InitBo('PM_MISSION', this.idRelation);
        break;
      case 'OBLIGATION':
        this.InitBo('BO_PARAMTASK', 'REL_BO_PAR_BO_PARAMTASK');
        break;
      //on crée le client ind avec les infos du bo_contact 
      case 'INDIVIDUEL':
        this.InitBo('CONTACT', 'REL_BO_CENT_BO_CONTACT');
        break;
    }

  }

  public OnMainContactChange(value: boolean): void {
    this.isMainContact = value;
    if (value) {
      this.InitBo('CONTACT', 'REL_BO_CPPT_BO_DIRIGEANT', false);
    } else {
      this.InitBo('CONTACT', 'REL_BO_CPPT_BO_CONTACT', false);
    }
  }

  public OnCustomerBoChange(value: string): void {
    switch (value.toUpperCase()) {
      case 'PROSPECT':
        this.InitBo('CUSTOMER', 'REL_BO_CENT_BO_CPPT');
        break;
      case 'CUSTOMER':
        this.InitBo('CUSTOMER', 'REL_BO_CENT_BO_CSOC');
        break;
    }
  }

  public OnDevisBoChange(value: any) {
    this.idDonneeFils = value;
    if ((!this.idDonneeFils || this.idDonneeFils === '0') && this.listValue.length > 0) {
      this.idDonneeFils = this.listValue[0].id;
    }
    this.InitBo('DEVIS', 'REL_BO_MFORADQ_BO_DEVIS');
  }

  public OnSaveBo(bo: BObjectModel): void {

    let _break: boolean = false;
    const queovalItem: QueovalItem = new QueovalItem();
    queovalItem.Value = bo.IdDonneeFils;
    switch (this.mode) {
      case 'CUSTOMER':
        this.http.getHttp<ActionCoBoModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Bo/CREATE_LEADER/${bo.IdDonneeFils}/`).subscribe(
          () => {
            let RaisoCLI: HtmlBase | null = null;

            const indexSelectGroup = bo.Body.SelectedGroupsList.findIndex(x => x.DataList.some(el => el.MainElementList.some(attribute => attribute.ID == 'RaisoCLI')));
            const indexDataList = bo.Body.SelectedGroupsList[indexSelectGroup].DataList.findIndex(el => el.MainElementList.some(attribute => attribute.ID == 'RaisoCLI'));
            const elementList = bo.Body.SelectedGroupsList[indexSelectGroup].DataList[indexDataList].MainElementList.find(e => e.ID == 'RaisoCLI');
            queovalItem.Text = elementList?.ID ?? '';

            /*       for (const selectedGroupsList of bo.Body.SelectedGroupsList) {
                     for (const dataList of selectedGroupsList.DataList) {
                       if (dataList && dataList.MainElementList != undefined) {
                         for (const mainElementList of dataList.MainElementList) {
                           if (mainElementList.ID === 'RaisoCLI') {
                             RaisoCLI = mainElementList;
                             _break = true;
                             break;
                           }
                         }
                       }
                       if (_break) break;
                     }
                     if (_break) break;
                   };
       
                   if (RaisoCLI != null) {
                     queovalItem.Text = RaisoCLI.Value;
                   }*/
            this.close.emit(queovalItem);
          });

        break;

      case 'INDIVIDUEL':
        //Appel serveur pour create le bo CPPT ou CSOC a partir des infos du contact
        this.http.getHttp<ActionCoBoModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Bo/CREATE_CLIENT_IND/${bo.IdDonneeFils}|${this.customerType}`).subscribe((data: ActionCoBoModel) => {

          if (!data.HasError) {
            queovalItem.Value = data.BusinessObject.IdDonneePere;
            //on emit un item avec juste l'id du client qui vient d'être crée pour le display géré dans action-co-action component
            this.close.emit(queovalItem);
          }

        });
        break;
      case 'CONTACT':

        _break = false;
        let Pre01PER: HtmlBase | null = null;
        let NomfaPER: HtmlBase | null = null;
        for (const selectedGroupsList of bo.Body.SelectedGroupsList) {
          for (const dataList of selectedGroupsList.DataList) {
            if (dataList && dataList.MainElementList != undefined) {
              for (const mainElementList of dataList.MainElementList) {
                if (mainElementList.ID === 'Pre01PER') {
                  Pre01PER = mainElementList;
                  if (NomfaPER != null) {
                    _break = true;
                    break;
                  }
                }
                if (mainElementList.ID === 'NomfaPER') {
                  NomfaPER = mainElementList;
                  if (Pre01PER != null) {
                    _break = true;
                    break;
                  }
                }
              }
            }
            if (_break) break;
          }
          if (_break) break;
        };
        if (NomfaPER != null || Pre01PER) {
          queovalItem.Text = `${NomfaPER != null ? NomfaPER.Value : ''} ${Pre01PER != null ? Pre01PER.Value : ''}`;
        }
        this.close.emit(queovalItem);

        break;
      case 'DEVIS':
        // Recuperation des valeurs Titre Info Commentaire Dossier
        queovalItem.Value = "RELOAD";
        this.close.emit(queovalItem);
        break;
      case 'ACTIONCO':
        // Recuperation des valeurs Titre Info Commentaire Dossier
        this.close.emit(queovalItem);
        break;
      default:
        this.close.emit(queovalItem);
        break;
    }
  }

  public ChangeCustomerType(event: any) {
    this.customerType = event;
  }

  public BoReady(model: BObjectModel) {
    console.log(model);
    //this.BoModel = model;
  }

  private InitBo(mode: string, relation: string, isReloading: boolean = true): void {
    this.isReloading = isReloading;
    switch (mode) {

      default:
        this.http.getHttp<ActionCoBoModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Bo/GET_BO/${mode}|${relation}|${this.idDonneePere}|${this.idDonneeFils}/`).subscribe(
          (result: ActionCoBoModel) => {
            const model: BObjectModel = (!isReloading) ? this.BoModel : new BObjectModel();

            if (isReloading) {
              model.IdDonneeFils = result.BusinessObject.IdDonneeFils;
              model.IdDonneePere = result.BusinessObject.IdDonneePere;
              model.IdentBO = result.BusinessObject.IdentBo;
              model.ShowSaveButton = true;
            } else {
              //param.params.push(new BreadDik('isloaded', true));
            }
            model.IdRelation = result.BusinessObject.IdRelation;

            this.BoModel = JSON.parse(JSON.stringify(model));

            this.isReloading = false;
          });
        break;

      case 'CONTACT':
      case 'CUSTOMER':
        this.http.getHttp<ActionCoBoModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Bo/GET_BO/${mode}|${relation}${this.idDonneePere ? `|${this.idDonneePere}` : ''}/`).subscribe(
          (result: ActionCoBoModel) => {
            const model: BObjectModel = (!isReloading) ? this.BoModel : new BObjectModel();
            if (isReloading) {
              //param.model = new BObjectModel();
             model.IdDonneeFils = '0';
             model.IdDonneePere = result.BusinessObject.IdDonneePere;
             model.IdentBO = result.BusinessObject.IdentBo;
             model.ShowSaveButton = true;
            } else {
             // param.params.push(new BreadDik('isloaded', true));
            }
            model.IdRelation = result.BusinessObject.IdRelation;      
            if (mode == 'CONTACT') {

              this.http.getHttp<QResult<Array<InputModel>>>(`${this.indParam.AppParams.apiUrl}api/ActionCo/PP_BO_INFO/${this.idDonneePere}`).subscribe(
                (result: QResult<Array<InputModel>>) => {
                  model.DefaultInputs = result.Value;
                  this.BoModel = JSON.parse(JSON.stringify(model));
                  this.isReloading = false;
                });
            } else {
              this.BoModel = JSON.parse(JSON.stringify(model));
              this.isReloading = false;
            }
          });
        break;
    }

  }

  public OnCancel(): void {
    this.close.emit(new QueovalItem());
  }
  // a la création du client penser à créer le dirigeant REL_BO_CPPT_BO_DIRIGEANT ou REL_BO_CSOC_BO_DIRIGEANT cf PageRechFiltre ligne 397
}
